import React from 'react';

const ViennoiserieIcon = ({ className, size = "h-6 w-6" }) => {
  return (
    <div className={`${size} relative overflow-hidden rounded-md ${className}`}>
      <img 
        src="https://customer-assets.emergentagent.com/job_baker-point-of-sale/artifacts/d7eif7ef_image.png" 
        alt="Viennoiseries artisanales" 
        className="w-full h-full object-cover"
        style={{
          objectPosition: 'center center'
        }}
      />
    </div>
  );
};

export default ViennoiserieIcon;